// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__FAO1J","selected":"Chip_selected__3g3rx"};